import { Box, Typography, Chip } from "@mui/material";
import { IconFileText } from "@tabler/icons-react";
import UploadInternacional from "../../../../models/uploadInternacional";
import { radius } from "../../../../theme";

type Props = {
  upload: UploadInternacional;
};

export default function CabecalhoStatement({ upload }: Props) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      paddingX={2}
      paddingY={3}
      gap={2}
    >
      {/* Título principal */}
      <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
        {/* Tile neutro com ícone em accent-ink — ícone em círculo de cor sólida
            é anti-padrão do sistema (DESIGN.md → Anti-padrões). */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={(theme) => ({
            width: 40,
            height: 40,
            flexShrink: 0,
            borderRadius: `${radius.md}px`,
            bgcolor: theme.palette.ink["08"],
            border: `1px solid ${theme.palette.divider}`,
            color: theme.palette.accentInk,
          })}
        >
          <IconFileText size={20} />
        </Box>
        <Box>
          <Typography variant="eyebrow" color="text.secondary">
            Internacional
          </Typography>
          <Typography variant="h1" color="text.primary">
            Statement Internacional
          </Typography>
          <Typography variant="dataMono" color="text.secondary">
            {upload.nomeArquivoOriginal}
          </Typography>
        </Box>
      </Box>

      {/* Informações adicionais */}
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap={1}
        flexWrap="wrap"
      >
        {upload.periodo && (
          <Chip
            label={`${upload.periodo.de.format(
              "DD/MM/YYYY"
            )} - ${upload.periodo.a.format("DD/MM/YYYY")}`}
            variant="outlined"
            size="small"
            sx={(theme) => ({
              borderColor: theme.palette.divider,
              color: theme.palette.accentInk,
              fontVariantNumeric: "tabular-nums",
            })}
          />
        )}

        {upload.instituicao && (
          <Chip
            label={upload.instituicao}
            variant="outlined"
            size="small"
            sx={(theme) => ({
              borderColor: theme.palette.divider,
              color: theme.palette.text.primary,
            })}
          />
        )}

        {upload.dataUpload && (
          <Chip
            label={`Importado em ${upload.dataUpload.format("DD/MM/YYYY")}`}
            variant="outlined"
            size="small"
            sx={(theme) => ({
              borderColor: theme.palette.divider,
              color: theme.palette.text.secondary,
              fontVariantNumeric: "tabular-nums",
            })}
          />
        )}
      </Box>
    </Box>
  );
}
